module.exports = __webpack_public_path__ + "static/media/tzum-min.bc27ce08.png";